import {Tooltip as LibTooltip} from '@mui/material'
import {TOOLTIP_PLACEMENTS} from './_constants'

import './index.scss'

export const Tooltip = ({arrow=true,...props}) => {
  const placement = TOOLTIP_PLACEMENTS.includes(props?.placement)
    ? props.placement
    : 'top'

  return (
    <LibTooltip
      {...props}
      arrow={arrow}
      placement={placement}
      PopperProps={{
        ...props?.PopperProps,
        className: `common-tooltip ${props?.className || ''}`,
      }}
    >
      <span>{props?.children}</span>
    </LibTooltip>
  )
}
